// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"288":"ebb8eadb","738":"b91e722f"}[chunkId] + ".chunk.css";
};